import { createFileRoute } from "@tanstack/react-router"
import { UserDetail } from "@/components/users"

export const Route = createFileRoute("/users/$userNumber/")({
  staticData: {
    title: 'User Detail',
    isSecured: true,
  },
  component: UserDetailPage,
})

function UserDetailPage() {
  const { userNumber } = Route.useParams()

  return (
    <div className="p-6">
      <UserDetail userNumber={parseInt(userNumber)} />
    </div>
  )
}
